import type { StripeElementLocale } from "@stripe/stripe-js"
import type { LanguageCode } from "~/consts/languages"

export const stripeLocaleLookup: {
  [language in LanguageCode]: StripeElementLocale
} = {
  nb: "nb",
  nn: "nb",
  en: "en",
}
